












































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import PromoNewsStore, { PromoNewsDetail, SystemCompanyNewsDetail } from '@/store/PromoNewsStore';
import MasterStore from '@/store/MasterStore';
import AppStore from '@/store/App';
import DateEditor from '@/components/material/editors/Date.vue';

@Component({
    components: {
        DateEditor,
    },
    watch: {
        'news.title': function (val, old) {
            const self = this as any;
            if(self.company.title == old)
                self.company.title = val;
        },
        'value': function(val, old) {
            console.log(val, old);
            const self = this as any;
            if(val && !old) {
                // Initialize
                if(!self.companyOnly) {
                    self.progress = false;
                    self.news.title = '';
                    self.news.content = '';
                    (self.$refs.file as HTMLInputElement).value = "";
                    self.enable_company = true;
                }
                self.company.title = '';
                self.company.expires = new Date(Date.now() + 1000 * 3600 * 24 * 7);
            }
        }
    }
})
export default class PromoNewsComposeDialog extends Vue {
    @Prop() value?: boolean;
    @Prop({ default: false }) companyOnly?: boolean;
    @Prop() newsId?: number;

    news: Partial<PromoNewsDetail> = {
        title: '',
        content: '',
    };

    photo: FileList | null = null;

    enable_company: boolean = true;

    company: Partial<SystemCompanyNewsDetail> = {
        title: '',
        expires: new Date(Date.now() + 1000 * 3600 * 24 * 7),
    };

    progress: boolean = false;

    async compose() {
        this.progress = true;

        let news_id: number = this.newsId !== undefined ? this.newsId : 0;
        if(!this.companyOnly) {
            // upload photo
            let photoPath: string = '';
            if(this.photo && this.photo.length > 0)
                photoPath = await MasterStore.uploadAsset(this.photo[0]);

            // compose news
            const composed: Partial<PromoNewsDetail> = {
                title: this.news.title,
                content: this.news.content,
                photo: photoPath,
                companyNewsId: 0,
            }

            news_id = await PromoNewsStore.createDetail(composed);
        }

        if(this.enable_company || this.companyOnly) {
            // upload company notification
            const composed_company: Partial<SystemCompanyNewsDetail> = {
                title: this.company.title,
                expires: this.company.expires,
                link: 'https://www.arrow-payment.com/news/' + news_id,
            };

            const company_id: number = await PromoNewsStore.createCompanyDetail(composed_company);
            
            // set companyNewsId
            const nval: PromoNewsDetail = Object.assign({}, PromoNewsStore.details[news_id]);
            nval.companyNewsId = company_id;
            console.log(nval)
            PromoNewsStore.modifyDetail(nval);
        }

        // close dialog
        this.progress = false;
        this.$emit('input', false);

        AppStore.showSuccess(
            !this.companyOnly
            ? '正常にお知らせを作成しました。'
            : '正常にシステム通知を発行しました。'
        );
    }
}
